<template>
  <div class="about_content" style="margin-top: 130px;">
    <!-- <div class="about_header"></div> -->
    <!-- tab栏点击跳转 -->
    <!-- <div style="border-bottom: 2px solid #F3F3F3;background-color: #56B275;">
      <div style="justify-content: center;width: 80vw;display: flex;padding: 20px;margin: 0 auto;">
        <div style="display: flex;flex-direction: row;justify-content: space-between;width: 100%;">
          <div class="about_title" @click="goAbout('section1')">{{ $t("user.chongqingcontent26") }}</div>
          <div class="about_title" @click="goAbout('section2')">{{ $t("user.chongqingcontent28") }}</div>
          <div class="about_title" @click="goAbout('section3')">{{ $t("user.aboutush3") }}</div>
          <div class="about_title" @click="goAbout('section4')">{{ $t("user.chongqingcontent33") }}</div>
          <div class="about_title" @click="goAbout('section5')">{{ $t("user.aboutust2") }}</div>
          <div class="about_title" @click="goAbout('section6')">{{ $t("user.chongqingcontent34") }}</div>
        </div>
      </div>
    </div> -->
    <div style="width: 100%; background-color: #56B275; height: 60px;padding: 0 3vw;">
      <ul
        style="display: flex; flex-direction: row; height: 60px; justify-content: space-between;  list-style: none; margin: 0;">
        <!-- 循环渲染选项，减少重复代码 -->
        <li v-for="(item, index) in items" :key="index" class="about_title" @click="goAbout(item.url)">
          <p :style="{
            fontSize: $i18n.locale === 'en' ? '16px' : '24px'
          }">
            {{ item.name }}
          </p>
          <!-- <p style="font-size: 14px; margin: 5px 0 0 0;">{{ $t("user.workcenter") }}</p> -->
        </li>
      </ul>
    </div>
    <!-- 企业介绍 -->
    <div class="aboutFurui">
      <div class="about_one"
        style="font-size: 35px;color: black;justify-content: center;flex-direction: column;margin-top: 80px;">
        <!-- <div class="blue_piece"></div> -->

        <div id="section1">企业介绍</div>
        <div style="display: flex;flex-direction: row;font-weight: normal;">
          <div class="line"></div>
          <div class="title" style="font-size: 25px;padding: 0 15px;">Company Introduction</div>
          <div class="line"></div>
        </div>
      </div>
      <div style="display: flex;flex-direction: row;justify-content: space-between;">
        <div class="about_content1" style="display: flex;flex-direction: column;width: 45%;box-sizing: border-box;">
          <h2>{{ $t("user.aboustus1") }}</h2>
          <p>{{ $t("user.homesynopsis") }}</p>
          <p>{{ $t("user.chongqingcontent2") }}</p>
          <p>
            {{ $t("user.chongqingcontent14") }}
          </p>
          <h2>{{ $t("user.aboutush2") }}</h2>
          <p>
            {{ $t("user.aboutusp3") }}
          </p>
          <p>{{ $t("user.aboutusp4") }}</p>

        </div>
        <img src="../assets/furuiImg/banner3.jpg" alt="" style="max-width: 50%;height: auto;margin: 40px 0;">
      </div>
    </div>
    <!--精品化管理 -->
    <!-- <el-carousel :interval="4000" type="card" height="200px" style="width: 50%;" :indicator-position="none"> -->
    <!-- <el-carousel-item v-for="item in 2" :key="item">
        <h3 class="medium">{{ item }}</h3>
      </el-carousel-item> -->
    <!-- <el-carousel-item>
        <h3 class="medium">这里是第 1 张内容</h3>
      </el-carousel-item>
      <el-carousel-item>
        <h3 class="medium">这里是第 2 张内容</h3>
      </el-carousel-item>
    </el-carousel> -->
    <!-- 企业文化 -->
    <img id="section2" src="../assets/furuiImg/about/企业文化.jpg" width="100%" style="margin-top: 80px;">
    <!-- 创新驱动 -->
    <!-- <div style="margin: 80px 0;">
      <div class=" about_one" style="font-size: 35px;color: black;justify-content: center;flex-direction: column;">
        <div id="section3">创新驱动</div>
        <div style="display: flex;flex-direction: row;font-weight: normal;">
          <div class="line"></div>
          <div class="title" style="font-size: 25px;padding: 0 15px;">Innovation driven</div>
          <div class="line"></div>
        </div>
        <div>
          <span
            style="font-size: 16px;font-weight: normal;color: #6B6666;text-align: center;">集团每年开展的研发项目>100项，每年专利申请>20个，每年投入的研发费用>主营业务收入的4%。</span>
        </div>
        <div class="stats-list">
          <div class="stat-item" v-for="(item, index) in stats" :key="index">
            <p class="stat-num">{{ item.num }}</p>
            <p class="stat-text">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 主要产品 -->
    <div class="aboutFurui">
      <div class="about_one"
        style="font-size: 35px;color: black;justify-content: center;flex-direction: column;margin-top: 80px;">
        <div id="section4">主要产品</div>
        <div style="display: flex;flex-direction: row;font-weight: normal;">
          <div class="line"></div>
          <div class="title" style="font-size: 25px;padding: 0 15px;">Main products</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="about_content1" style="text-indent: 2em">
        {{ $t("user.aboutusp5") }}
      </div>
      <div style="display: flex;justify-content: space-between;margin-top: 30px;">
        <img src="../assets/furuiImg/about/图2.png" style="width: 47%;" alt="">
        <img src="../assets/furuiImg/about/图3.png" style="width: 47%;" alt="">
      </div>
    </div>
    <!-- 发展历程 -->
    <div style="margin: 80px 0;">
      <div class=" about_one" style="font-size: 35px;color: black;justify-content: center;flex-direction: column;">
        <div id="section5">发展历程</div>
        <div style="display: flex;flex-direction: row;font-weight: normal;">
          <div class="line"></div>
          <div class="title" style="font-size: 25px;padding: 0 15px;">Development history</div>
          <div class="line"></div>
        </div>

      </div>
      <div class="development-timeline">
        <!-- 时间轴 + 内容 纵向循环 -->
        <div v-for="(stage, index) in developmentStages" :key="index" class="timeline-item">
          <!-- 右侧内容卡片 -->
          <div class="timeline-col timeline-col--right">
            <div class="stage-card">
              <h3 class="stage-title">{{ stage.title }}</h3>
              <p class="stage-desc">{{ stage.desc }}</p>
            </div>
          </div>
          <!-- 左侧时间轴节点 -->
          <div class="timeline-col timeline-col--left">
            <div class="dot"></div>
            <div class="year">{{ stage.year }}</div>
            <!-- 纵向竖线（仅在非最后一个显示） -->
            <div class="vertical-line" v-if="index !== developmentStages.length - 1"></div>
          </div>

        </div>
      </div>
    </div>
    <!-- 企业荣耀 -->
    <div class="about_three">
      <div class="aboutt_content">
        <div class="about_one"
          style="font-size: 35px;color: black;justify-content: center;flex-direction: column;padding-top: 80px;">
          <div id="section6">企业荣誉</div>

          <div style="display: flex;flex-direction: row;font-weight: normal;">
            <div class="line"></div>
            <div class="title" style="font-size: 25px;padding: 0 15px;">Corporate Honors</div>
            <div class="line"></div>
          </div>
        </div>
      </div>
      <div class="about_content1" style="text-indent: 2em;padding: 0 2vw;">{{ $t("user.companyhonist") }}</div>
      <!-- 证书轮播区域 -->
      <div class="honor-carousel" style="margin-top: 0px;">
        <!-- 左侧箭头 -->
        <button class="carousel-arrow prev-arrow" @click="prevSlide">
          <i class="el-icon-arrow-left"></i>
        </button>
        <!-- 证书容器：去掉 `:style` 动态偏移，改为固定宽度 + 居中 -->
        <div class="carousel-track" style="height: 300px;">
          <!-- 左侧 -->
          <div class="carousel-slide" :class="{ 'side-slide': true }" style="left: -200px;">
            <img :src="getSlideImage(-1)" alt="honor" class="honor-img" />
            <p class="honor-label">{{ getSlideLabel(-1) }}</p>
          </div>
          <!-- 当前 -->
          <div class="carousel-slide active-slide" style="left: 50%;">
            <img :src="getSlideImage(0)" alt="honor" class="honor-img" />
            <p class="honor-label">{{ getSlideLabel(0) }}</p>
          </div>
          <!-- 右侧 -->
          <div class="carousel-slide" :class="{ 'side-slide': true }" style="left: 200px;">
            <img :src="getSlideImage(1)" alt="honor" class="honor-img" />
            <p class="honor-label">{{ getSlideLabel(1) }}</p>
          </div>
        </div>
        <!-- 右侧箭头 -->
        <button class="carousel-arrow next-arrow" @click="nextSlide">
          <i class="el-icon-arrow-right"></i>
        </button>

      </div>
      <div style="margin-top: 30px;display: flex;justify-content: center;margin-bottom: 30px;">
        <ul style="list-style-type: disc; padding-left: 25px; margin: 0;">
          <li class="lidec">{{ $t("user.honorListp1") }}</li>
          <li class="lidec">{{ $t("user.honorListp2") }}</li>
          <li class="lidec">{{ $t("user.honorListp3") }}</li>
          <li class="lidec">{{ $t("user.honorListp4") }}</li>
          <li class="lidec">{{ $t("user.honorListp5") }}</li>
        </ul>
      </div>
    </div>
    <!-- <div class="about_one">
          <div class="blue_piece"></div>
          <p>{{ $t("user.chongqingcontent5") }}</p>
        </div>
        <div class="title_box">{{ $t("user.chongqingcontent6") }}</div>
        <div class="heng_line"></div> -->
    <!-- <div class="device_box">
          <img src="../assets/furuiImg/aboutus/图片1.png" alt="" />
          <img src="../assets/furuiImg/aboutus/图片2.png" alt="" />
        </div> -->
    <!-- <div class="aboutus_four">
      <div class="aboutf_content">
        <div class="about_one">
          <div class="blue_piece"></div>
          <p>{{ $t("user.chongqingcontent7") }}</p>
        </div>
        <div class="title_box">{{ $t("user.chongqingcontent8") }}</div>
        <div class="heng_line"></div>
        <div><img src="../assets/furuiImg/aboutus/图片3.png" alt="" /></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { honor, compony } from "@/api/index"
import { get } from "jquery";
export default {
  data() {
    return {
      honorList: [
        {
          image: require('@/assets/furuiImg/about/honorList1.jpg'), // 替换为实际证书图片路径
          label: '省级“专精特新”企业'
        },
        {
          image: require('@/assets/furuiImg/about/honorList2.jpg'),
          label: '高新技术企业证书'
        },
        {
          image: require('@/assets/furuiImg/about/honorList3.jpg'),
          label: '福建省“专精特新”中小企业'
        },
        {
          image: require('@/assets/furuiImg/about/honorList4.jpg'),
          label: '市级企业技术中心'
        },
        {
          image: require('@/assets/furuiImg/about/honorList5.png'),
          label: '质量管理体系认证证书'
        },
        {
          image: require('@/assets/furuiImg/about/honorList6.png'),
          label: '莆田市市级工业设计中心'
        },
        {
          image: require('@/assets/furuiImg/about/honorList7.png'),
          label: '2024年突出经济贡献'
        },
        {
          image: require('@/assets/furuiImg/about/honorList8.png'),
          label: '2022年突出经济贡献'
        },
        {
          image: require('@/assets/furuiImg/about/honorList9.png'),
          label: '2021年突出经济贡献'
        },
        {
          image: require('@/assets/furuiImg/about/honorList10.png'),
          label: '福建省机床工具行业协会'
        },
        {
          image: require('@/assets/furuiImg/about/honorList11.png'),
          label: '第四届理事单位'
        },
        {
          image: require('@/assets/furuiImg/about/honorList12.png'),
          label: '研究生联合培养基地'
        },
        {
          image: require('@/assets/furuiImg/about/honorList13.png'),
          label: '副会长单位'
        },
      ],
      developmentStages: [
        { year: '2000年-2008年', title: '专业', desc: '致力于机加工业务的开拓与精进。' },
        { year: '2009年-2014年', title: '建设', desc: '建立数控装备自动化生产线。' },
        { year: '2015年-2019年', title: '选择', desc: '从第一台加工中心开始，经5年努力，光机销量破1000+。' },
        { year: '2020年-2024年', title: '发展', desc: '自主研发、自主设计，获得“国家高新技术企业、国家知识产权优势企业、省龙头企业、省专精特新企业等，光机销售破3000+。' },
        // 可继续扩充更多阶段
      ],
      currentSlide: 1, // 当前显示的证书索引
      slideWidth: 320,// 单个证书宽度（含 margin）
      totalSlides: 0,
      currentIndex: 0,
      stats: [
        {
          num: '2000万',
          text: '年产真空管2000万'
        },
        {
          num: '100万',
          text: '年产太阳能100万套'
        },
        {
          num: '3000+家',
          text: '线下网点3000余家'
        },
        {
          num: '8000+辆',
          text: '售后服务车8000余辆'
        },
        {
          num: '80000吨',
          text: '8万吨3.3高硼硅玻璃管'
        },
        {
          num: '100+',
          text: '太阳能相关产品100多个系列'
        }
      ],
      items: [
        { name: this.$t("user.chongqingcontent26"), url: 'section1' },
        { name: this.$t("user.chongqingcontent28"), url: 'section2' },
        // { name: this.$t("user.aboutush3"), url: 'section3' },
        { name: this.$t("user.chongqingcontent33"), url: 'section4' },
        { name: this.$t("user.aboutust2"), url: 'section5' },
        { name: this.$t("user.chongqingcontent34"), url: 'section6' },
        { name: this.$t("user.management"), url: 'section7' },
        // { name: this.$t("user.work7") }
      ],
    };
  },
  created() {
    console.log(this.$route.query.type);  // 输出: 'company'
    console.log(this.$route.query.id);    // 输出: 123
  },
  mounted() {
    this.totalSlides = this.honorList.length;
    this.handleHashScroll();
    // 监听路由变化（如果同一页面哈希变化也需要处理）
    this.$watch('$route', () => {
      this.handleHashScroll();
    });
    // this.gethonor();


  },
  computed: {
    // 当前显示的阶段
    visibleStages() {
      return [this.developmentStages[this.currentIndex]]
    }
  },
  methods: {
    // gethonor() {
    //   compony().then(res => {
    //     console.log(res);
    //     // this.honorList = res.data;
    //   })
    // },
    goAbout(sectionId) {
      // 获取目标元素
      const targetElement = document.getElementById(sectionId);
      if (targetElement) {
        // 计算目标位置（元素顶部位置 - 80px偏移）
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 80;

        // 平滑滚动到目标位置
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth' // 平滑滚动效果
        });
      }
      if (sectionId == 'section7') {
        this.$router.push("/management");
      }
    },
    adjustCarousel() {
      this.$nextTick(() => {
        const track = this.$el.querySelector('.carousel-track');
        const slides = track.querySelectorAll('.carousel-slide');

        if (!slides.length) return;

        const containerWidth = this.$el.querySelector('.honor-carousel').offsetWidth;
        const slideWidth = slides[0].offsetWidth;
        const gap = 100; // 每个 slide 的左右重叠量（跟 CSS 的负 margin 一致）

        // 计算当前 active 图片应居中的偏移量
        const offset = (slideWidth + -gap) * this.currentSlide;

        // 设置 transform 让当前项居中
        track.style.transform = `translateX(${containerWidth / 2 - offset - slideWidth / 2}px)`;
      });
    },
    getSlideIndex(offset) {
      const len = this.honorList.length;
      return (this.currentSlide + offset + len) % len;
    },
    getSlideImage(offset) {
      const index = this.getSlideIndex(offset);
      return this.honorList[index].image;
    },
    getSlideLabel(offset) {
      const index = this.getSlideIndex(offset);
      return this.honorList[index].label;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.honorList.length) % this.honorList.length;
    },
    nextSlide() {
      const activeSlide = document.querySelector('.active-slide');
      if (activeSlide) activeSlide.classList.remove('active-slide');

      // 延迟更新索引，确保过渡动画触发（关键）
      setTimeout(() => {
        this.currentSlide = (this.currentSlide + 1) % this.honorList.length;
        // 重新添加活跃状态
        if (activeSlide) activeSlide.classList.add('active-slide');
      }, 50); // 50ms延迟让CSS过渡生效
    },
    handleHashScroll() {
      // 获取URL中的哈希（如#section1 -> section1）
      const hash = window.location.hash.replace('#', '');
      console.log('选项', hash);
      if (hash) {
        this.scrollToSection(hash);
      }
    },
    scrollToSection(sectionId) {
      // 确保DOM渲染完成
      this.$nextTick(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          // 减去导航栏高度（根据实际导航栏高度调整）
          const navbarHeight = 80;
          const targetTop = element.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
          console.log('目标位置', targetTop);
          window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
          });
        } else {
          console.log(`未找到ID为${sectionId}的元素`); // 调试用
        }
      });
    },
    prevStage() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.scrollToCurrent();
      }
    },
    nextStage() {
      if (this.currentIndex < this.developmentStages.length - 1) {
        this.currentIndex += 1;
        this.scrollToCurrent();
      }
    },
    handleTimelineClick(index) {
      this.currentIndex = index;
      this.scrollToCurrent();
    },
    scrollToCurrent() {
      const currentItem = this.$el.querySelector(`.timeline-item:nth-child(${this.currentIndex + 1})`);
      // if (currentItem) {
      //   currentItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // }
    }

  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .about_header {
    height: 270px !important;
  }
}

::v-deep .el-carousel__arrow--left {
  left: 20px;
  /* 原默认值可能很大，调小 */
}

// 精品化管理
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.about_title {
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  color: white
}

.about_title:hover {
  color: #66B782;
  background-color: white;
  cursor: pointer;
}

.stats-list {
  display: flex;
  flex-wrap: wrap;
  /* 允许换行 */
  gap: 20px;
  /* 元素之间的间距 */
  padding: 0;
  margin: 0;
  list-style: none;
}

.stat-item {
  width: calc(33.333% - 14px);
  /* 三分之一宽度减去间隙的2/3 */
  box-sizing: border-box;
  /* 确保padding和border不影响宽度 */
  text-align: center;
  padding: 15px;
  /* 保留原有的边框样式（如果需要） */
  // border-left: 2px solid #CFCFCF;
}

/* 移除第一个元素的左边框（可选优化） */
.stat-item:first-child {
  border-left: none;
}

.stat-num {
  font-size: 30px;
  color: #333;
  margin: 0 0 10px 0;
}

.stat-text {
  margin: 0;
  color: #6B6666;
  font-size: 18px;
}

.honor-label {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: #66B782;
  color: white;
}

.lidec {
  list-style-type: disc;
  margin-bottom: 10px;
}

/* 轮播区域布局 */
.honor-carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: visible;
  padding: 0 200px;
}

.carousel-track {
  display: flex;
  justify-content: center;
  align-items: center;
  // gap: -1500px;
  // left: 325px;
  // position: relative;
}

.carousel-slide {
  width: 300px;
  // transition: transform 0.5s ease;
  z-index: 1;
  opacity: 0.6;
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform: scale(0.8);
}

.carousel-slide img {
  width: 100%;
  border-radius: 4px;
}

.active-slide {
  transform: scale(1.2);
  z-index: 10;
  opacity: 1;
}

.side-slide {
  transform: scale(0.9); // 侧边项略小于活跃项
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  // transform: translateY(-50%);
  z-index: 20;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

// .carousel-arrow:hover {
//   background: rgba(0, 0, 0, 0.5);
//   transform: translateY(-50%) scale(1.1);
// }
// 图片加载动画（可选）
.honor-img {
  transition: all 0.5s ease;

  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15); // 鼠标悬停时添加阴影
  }
}

.prev-arrow {
  left: 190px;
}

.next-arrow {
  right: 190px;
}

.line {
  flex: 1;
  height: 2px;
  background: #000;
  width: 50px;
  align-items: center;
  display: flex;
  margin-top: 18px;
  // justify-content: center;
}

.about_content1 {
  // margin-top: 30px;
  /* 和标题区域拉开间距 */
  line-height: 1.8;
  /* 让段落文字行间距更舒适 */
  color: #333;
  /* 设置文字颜色，提升可读性 */
}

.about_content1 h2 {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0 10px;
  /* 标题上下间距 */
  position: relative;
  padding-left: 10px;
}

.about_content1 h2::before {
  content: "";
  position: absolute;
  left: 1%;
  top: 150%;
  transform: translateY(-50%);
  width: 18px;
  height: 3px;
  background-color: #56B275;
  /* 标题左侧小竖线颜色，可调整 */
}

.about_content1 p {
  // text-indent: 2em;
  /* 段落首行缩进两个字符，中文排版更规范 */
  margin-top: 5px;
  font-size: 18px;
  text-align: justify;
  hyphens: auto;
}

.about_content {
  width: 100%;

  .aboutus_four {
    width: 100%;
    background: url(../assets/furuiImg/aboutus/背景.png);
    background-size: cover;
    background-position: center;
    padding-bottom: 30px;

    .aboutf_content {
      width: 80vw;
      margin: 80px auto;

      >div>img {
        width: 100%;
      }
    }
  }

  .about_header {
    width: 100%;
    height: 520px;
    background: url(../assets/furuiImg/about/banner.png);
    background-size: cover;
    background-position: center;
    margin-top: 80px;
  }

  .aboutFurui {
    width: 100vw;
    // margin: 40px auto;
    padding: 0 2vw;

    .about_two {
      font-size: 30px;
      font: black;
    }

    .about_three {
      width: 100%;
      height: 1px;
      margin: 30px auto;
      background-color: rgb(167, 165, 165);
    }

    .about_four {
      line-height: 3;
      text-indent: 4ch;
    }
  }

  .title_box {
    font-size: 32px;
  }

  .about_one {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 20px;
    margin-bottom: 10px;

    .blue_piece {
      height: 11px;
      width: 5px;
      background-color: blue;
      margin-right: 10px;
    }
  }

  .heng_line {
    width: 100%;
    height: 1px;
    background-color: rgb(181, 181, 181);
    margin: 20px 0;
  }

  .about_three {
    background: url(../assets/furuiImg/about/荣誉证书背景.png);
    width: 100%;
    background-color: #ebeef5;
    padding-bottom: 30px;

    .aboutt_content {
      width: 80vw;
      margin: 0 auto;
      padding: 0px 0;

      .device_box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        >img {
          width: 38vw;
        }
      }
    }
  }

  .about_four {
    width: 100%;

    .aboutf_content {
      width: 80vw;
      margin: 0 auto;
    }
  }
}

// 发展历程
.development-timeline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px;
}

/* 每个时间轴项：水平排列（左侧节点+右侧卡片） */
.timeline-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
  /* 项与项间距 */
  width: 100%;
  border-radius: 8px;
}

/* 左侧时间轴列：垂直排列（圆点+年份+竖线） */
.timeline-col--left {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  /* 与卡片间距 */
  position: relative;
  /* 给竖线做容器 */
}

/* 时间点小圆点 */
.dot {
  width: 16px;
  height: 16px;
  background: #28a745;
  border-radius: 50%;
  margin-bottom: 8px;
}

/* 年份文字 */
.year {
  color: #28a745;
  font-weight: 500;
  margin-bottom: 16px;
}

/* 纵向竖线：连接上下节点 */
.vertical-line {
  width: 2px;
  height: 100%;
  background: #28a745;
  position: absolute;
  left: 50%;
  top: calc(100% + 8px);
  /* 从圆点下方开始 */
  transform: translateX(-50%);
  animation: growLine 1s ease-in-out forwards;
}

@keyframes growLine {
  from {
    height: 0%;
  }

  to {
    height: 100%;
  }
}

.timeline-item:nth-child(even) .stage-card {
  background-color: #f9f9f9;
}

/* 右侧内容卡片：占满剩余宽度 */
.timeline-col--right {
  flex: 1;
}

.stage-card {
  background: linear-gradient(to right, #66B782, #f0f0f0);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 95%;
  color: white;
}

.stage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stage-title {
  font-size: 20px;
  margin-bottom: 8px;
}

.stage-desc {
  color: white;
  line-height: 1.6;
}
</style>